import React, { useState, useEffect } from "react";
import { logout } from "../services/authService";
import { useMsal } from "@azure/msal-react";
import { useHistory } from "react-router-dom";
import { LoadingSpinnerAlt } from "../components/common/LoadingSpinnerAlt";
import { StartupPageTemplate } from "../components/startup-pages/StartupPageTemplate";
import { getDiseaseGroup, setDiseaseGroup } from "../services/userService";
import { clearLocalStorage } from "../services/authService";

export const LoginErrorRecoveryPage = () => {
	const { instance, accounts } = useMsal();
	const history = useHistory();

	useEffect(() => {
		if (accounts.length === 0) {
			const diseaseGroup = getDiseaseGroup();

			// localStorage.clear();
			clearLocalStorage();

			if (diseaseGroup) {
				setDiseaseGroup(diseaseGroup);
			}

			history.push("/");
		} else {
			const activeAccount = instance.getActiveAccount() ?? accounts[0];
			logout(instance, activeAccount);
		}
	}, []);

	return (
		<StartupPageTemplate>
			<LoadingSpinnerAlt />
		</StartupPageTemplate>
	);
};
